import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "../components/Styles/home.css";

import xm1 from "../assets/images/xm1.png";
import xmini from "../assets/images/xmini.png";
import xmidmin from "../assets/images/xmid-min.png";
import xmidminn from "../assets/images/xmid3-min.png";
import mainab from "../assets/images/mainab.png";
import mainac from "../assets/images/mainac.png";
import second from "../assets/images/second.png";
import third from "../assets/images/third.png";
import fourth from "../assets/images/fourth.png";
import fifth from "../assets/images/fifth.png";
import wifi from "../assets/images/wifi.png";
import pantry from "../assets/images/pantry.png";
import printer from "../assets/images/printer.png";
import lounge from "../assets/images/lounge.png";
import helpdesk from "../assets/images/helpdesk.png";
import prooms from "../assets/images/prooms.png";
import dollor from "../assets/images/dollor.png";
import tea from "../assets/images/tea.png";
import msrooms from "../assets/images/mrooms.png";

import AOS from "aos";
import "aos/dist/aos.css";
import Slide from "./Slide";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []); // ✅ fixed: run only once

  return (
    <div>
      <section className="main">
        <div className="main_sec">
          <h1>
            Space Ready
            <br />
            <span style={{ color: "#EEBD2B" }}>For Work</span>
          </h1>
          <p>
            Elevate your work experience in our meticulously designed
            workspaces, tailored for professionals seeking excellence and
            comfort. Join us and transform the way you work.
          </p>

          <button>
            Get Started <span style={{ fontWeight: "600px" }}>&#10140;</span>
          </button>{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: "1" }}>
            Schedule Tour
          </button>
        </div>
      </section>

      <br /><br /><br />

      <section>
        <div className="main_section">
          <h2>Our Workspace Solutions</h2>
          <p>Choose the perfect workspace that fits your needs</p>
          <div className="row_main_section">
            <div className="row_main_col">
              <img src={second} alt="" />
              <h3>Office Space</h3>
              <p>Tailored spaces designed for maximum productivity.</p>
            </div>
            <div className="row_main_col">
              <img src={third} alt="" />
              <h3>Dedicated Desk</h3>
              <p>Your personal nook in a vibrant professional community</p>
            </div>
            <div className="row_main_col">
              <img src={fourth} alt="" />
              <h3>Meeting Room</h3>
              <p>Modern rooms equipped for successful collaborations</p>
            </div>
          </div>
        </div>
      </section>

      <br /><br /><br />

      <section style={{ background: "#0D0D0D", padding: "3%" }}>
        <div className="main_section">
          <div className="row__4">
            <div className="col__4">
              <h2>
                How does it feel to cowork at{" "}
                <span style={{ color: "#EEBD2B" }}>The Xceed?</span>
              </h2>
              <br />
              <p>
                Surround yourself in a natural environment that resembles the
                farmlands of the midwest. Lay your laptop on a century old
                reclaimed wood table in one of the oldest historic Soho lofts
                to date and focus on your work via using a solid fast Wi-Fi.
              </p>
            </div>

            <div className="col__4">
              <img src={fifth} alt="" />
            </div>
          </div>
        </div>
      </section>

      <br /><br /><br />

      <section
        style={{
          background: "black",
          paddingTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <div
          className="last_section"
          style={{ width: "80%", margin: "auto", textAlign: "center" }}
        >
          <h2>Ready to Take the Next Step?</h2>
          <br />
          <p>
            Join the Xceed Office community today and elevate your work
            experience. Discover how our workspace can help you achieve more.
          </p>
          <br />
          <button>&#128198; Book a Meeting &#10140;</button> &nbsp;
          <button style={{ color: "white", background: "black" }}>
            <span style={{ color: "white" }}>&#9742;</span> Call Us Now
          </button>
          <br />
          <p className="lstt">
            Have questions? Call us at{" "}
            <a href="tel:+12817176060">(281) 717-6060</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;